import { useEffect } from "react";
// NOTE: ReplicatedObjectEvent must be placed at root level (top-level object keys) of ReplicatedObjectView.
export class ReplicatedObjectEvent {
    constructor(isActive) {
        this.revisionRef = { current: 0 };
        this.validRevision = 0;
        this.isActiveInternal = isActive;
    }
    setRevision(revisionRef) {
        this.revisionRef = revisionRef;
        this.validRevision = revisionRef.current;
    }
    isActive() {
        return this.isActiveInternal && this.validRevision === this.revisionRef.current;
    }
}
export const useReplicatedObjectEvent = (event, handler) => {
    useEffect(() => {
        if (event && event.isActive()) {
            return handler();
        }
    }, [event]);
};
//# sourceMappingURL=ReplicatedObjectView.js.map